import React from 'react';
import { ShowButton, DateInput, Datagrid, DateField, TextField, Filter, TextInput, SelectInput } from 'react-admin';
import TList from 'cw-core-admin-ui/src/components/wrapper/TList';
import { AmountField, LinkField } from 'cw-core-admin-ui/src/components/fields';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from 'cw-core-admin-ui/src/components/helper/DateHelper';
import LoyaltyCreditListActions from './LoyaltyCreditListActions';
import { loyaltyCreditActionForSelection } from '../loyaltyCredits/LoyaltyCreditConstants';
import { loyaltyCreditStatusForSelection } from '../loyaltyCredits/LoyaltyCreditConstants';
import { loyaltyCreditOwnerTypeForSelection } from '../loyaltyCredits/LoyaltyCreditConstants';

const LoyaltyCreditFilter = (props) => (
	<Filter {...props}>
		<TextInput resettable source="loyaltyProgramMembershipId" label="resources.loyaltyCredits.filter.loyaltyProgramMembershipId" />
		<TextInput resettable source="ownerId" label="resources.loyaltyCredits.filter.ownerId" />
		<SelectInput resettable source="ownerType" label="resources.loyaltyCredits.filter.ownerType" choices={loyaltyCreditOwnerTypeForSelection} />
		<SelectInput resettable source="loyaltyCreditAction" label="resources.loyaltyCredits.filter.action" choices={loyaltyCreditActionForSelection} />
		<SelectInput resettable source="loyaltyCreditStatus" label="resources.loyaltyCredits.filter.status" choices={loyaltyCreditStatusForSelection} />
		<DateInput resettable source="fromDate" label="resources.loyaltyCredits.filter.fromDate" parse={(value) => toApiDateTimeFormat(value)} format={(value) => toJavaScriptDateFormat(value)} />
		<DateInput resettable source="untilDate" label="resources.loyaltyCredits.filter.untilDate" parse={(value) => toApiDateTimeFormat(value)} format={(value) => toJavaScriptDateFormat(value)} />
	</Filter>
);

export default (props) => (
	<TList exporter={false} {...props} loyaltyProgramId={props.filter.id} filters={<LoyaltyCreditFilter />} actions={<LoyaltyCreditListActions />}>
		<Datagrid>
			<ShowButton />
			<TextField source="id" />
			<LinkField source="loyaltyProgramMembershipId" type="LoyaltyProgramMembership" />
			<LinkField source="owner" />
			<TextField source="action" />
			<TextField source="status" />
			<AmountField source="amount" />
			<DateField source="creationDateTime" showTime />
		</Datagrid>
	</TList>
);
